import { merge, omit, union } from 'ramda'
import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.B_RATES_FETCH_SUCCESS:
        case ActionTypes.B_RATES_IMPORT_SUCCESS:
            const { rates } = action.entities
            return { rates: merge(state.rates, rates) }
        case ActionTypes.B_RATES_SAVE_SUCCESS:
            return { ...state, rates: { ...state.rates, ...action.data.entities.rates } }
        case ActionTypes.B_RATES_DELETE_SUCCESS:
            return { rates: omit([action.data], state.rates) }
        case ActionTypes.B_CURRENT_ORGANIZATION_CHANGE:
            return {}
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.B_RATES_FETCH_SUCCESS:
        case ActionTypes.B_RATES_IMPORT_SUCCESS:
            return union(state, action.result)
        case ActionTypes.B_RATES_SAVE_SUCCESS:
            return union(state, [action.data.result])
        case ActionTypes.B_RATES_DELETE_SUCCESS:
            return state.filter(item => item !== action.data)
        case ActionTypes.B_CURRENT_ORGANIZATION_CHANGE:
            return []
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.B_RATES_FETCH_REQUEST:
            return true
        case ActionTypes.B_RATES_FETCH_SUCCESS:
        case ActionTypes.B_RATES_FETCH_FAILURE:
        case ActionTypes.B_RATES_SAVE_SUCCESS:
        case ActionTypes.B_RATES_IMPORT_SUCCESS:
        case ActionTypes.B_RATES_SAVE_FAILURE:
        case ActionTypes.B_RATES_DELETE_SUCCESS:
        case ActionTypes.B_RATES_DELETE_FAILURE:
        case ActionTypes.B_RATES_IMPORT_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.B_RATES_FETCH_FAILURE:
        case ActionTypes.B_RATES_SAVE_FAILURE:
        case ActionTypes.B_RATES_DELETE_FAILURE:
        case ActionTypes.B_RATES_IMPORT_FAILURE:
            return action.error
        case ActionTypes.B_RATES_FETCH_SUCCESS:
        case ActionTypes.B_RATES_SAVE_SUCCESS:
        case ActionTypes.B_RATES_DELETE_SUCCESS:
        case ActionTypes.B_RATES_IMPORT_SUCCESS:
            return null
        default:
            return null
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/bookingReducers/bookingRates.js